import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
var VeltCommentsSidebarFilterSearchInput = function (props) {
    var children = props.children, placeholder = props.placeholder, remainingProps = __rest(props, ["children", "placeholder"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-search-input-wireframe", __assign({}, transformedProps, { placeholder: placeholder }), children));
};
export default VeltCommentsSidebarFilterSearchInput;
